/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { UpdateDevicesParamsBody } from '../model';
// @ts-ignore
import { UpdateDevicesResponse } from '../model';
/**
 * DevicesApi - axios parameter creator
 * @export
 */
export const DevicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証のトークンで持っているSessionIDで指定された端末を削除する
         * @summary 認証のトークンで持っているSessionIDで指定された端末を削除する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionDevice: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/session/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーの端末を作成するもしくは入れ替える。認証のトークンで持っているSessionIDで指定された端末が存在する場合は何もしない。
         * @summary ユーザーの端末を作成するもしくは入れ替える。認証のトークンで持っているSessionIDで指定された端末が存在する場合は何もしない。
         * @param {UpdateDevicesParamsBody} [updateDevicesParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevices: async (updateDevicesParamsBody?: UpdateDevicesParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDevicesParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーの端末を検証する
         * @summary ユーザーの端末を検証する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyDevice: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevicesApi - functional programming interface
 * @export
 */
export const DevicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 認証のトークンで持っているSessionIDで指定された端末を削除する
         * @summary 認証のトークンで持っているSessionIDで指定された端末を削除する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSessionDevice(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSessionDevice(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーの端末を作成するもしくは入れ替える。認証のトークンで持っているSessionIDで指定された端末が存在する場合は何もしない。
         * @summary ユーザーの端末を作成するもしくは入れ替える。認証のトークンで持っているSessionIDで指定された端末が存在する場合は何もしない。
         * @param {UpdateDevicesParamsBody} [updateDevicesParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevices(updateDevicesParamsBody?: UpdateDevicesParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDevicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevices(updateDevicesParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーの端末を検証する
         * @summary ユーザーの端末を検証する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyDevice(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyDevice(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DevicesApi - factory interface
 * @export
 */
export const DevicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevicesApiFp(configuration)
    return {
        /**
         * 認証のトークンで持っているSessionIDで指定された端末を削除する
         * @summary 認証のトークンで持っているSessionIDで指定された端末を削除する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionDevice(options?: any): AxiosPromise<void> {
            return localVarFp.deleteSessionDevice(options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーの端末を作成するもしくは入れ替える。認証のトークンで持っているSessionIDで指定された端末が存在する場合は何もしない。
         * @summary ユーザーの端末を作成するもしくは入れ替える。認証のトークンで持っているSessionIDで指定された端末が存在する場合は何もしない。
         * @param {UpdateDevicesParamsBody} [updateDevicesParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevices(updateDevicesParamsBody?: UpdateDevicesParamsBody, options?: any): AxiosPromise<UpdateDevicesResponse> {
            return localVarFp.updateDevices(updateDevicesParamsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーの端末を検証する
         * @summary ユーザーの端末を検証する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyDevice(options?: any): AxiosPromise<void> {
            return localVarFp.verifyDevice(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevicesApi - interface
 * @export
 * @interface DevicesApi
 */
export interface DevicesApiInterface {
    /**
     * 認証のトークンで持っているSessionIDで指定された端末を削除する
     * @summary 認証のトークンで持っているSessionIDで指定された端末を削除する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApiInterface
     */
    deleteSessionDevice(options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * ユーザーの端末を作成するもしくは入れ替える。認証のトークンで持っているSessionIDで指定された端末が存在する場合は何もしない。
     * @summary ユーザーの端末を作成するもしくは入れ替える。認証のトークンで持っているSessionIDで指定された端末が存在する場合は何もしない。
     * @param {UpdateDevicesParamsBody} [updateDevicesParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApiInterface
     */
    updateDevices(updateDevicesParamsBody?: UpdateDevicesParamsBody, options?: AxiosRequestConfig): AxiosPromise<UpdateDevicesResponse>;

    /**
     * ユーザーの端末を検証する
     * @summary ユーザーの端末を検証する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApiInterface
     */
    verifyDevice(options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * DevicesApi - object-oriented interface
 * @export
 * @class DevicesApi
 * @extends {BaseAPI}
 */
export class DevicesApi extends BaseAPI implements DevicesApiInterface {
    /**
     * 認証のトークンで持っているSessionIDで指定された端末を削除する
     * @summary 認証のトークンで持っているSessionIDで指定された端末を削除する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public deleteSessionDevice(options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).deleteSessionDevice(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーの端末を作成するもしくは入れ替える。認証のトークンで持っているSessionIDで指定された端末が存在する場合は何もしない。
     * @summary ユーザーの端末を作成するもしくは入れ替える。認証のトークンで持っているSessionIDで指定された端末が存在する場合は何もしない。
     * @param {UpdateDevicesParamsBody} [updateDevicesParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public updateDevices(updateDevicesParamsBody?: UpdateDevicesParamsBody, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).updateDevices(updateDevicesParamsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーの端末を検証する
     * @summary ユーザーの端末を検証する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public verifyDevice(options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).verifyDevice(options).then((request) => request(this.axios, this.basePath));
    }
}
